import React from 'react';
import { SelectConnection } from 'new/elements/flows/SelectConnection';
import { FCFormPageType, useForm } from 'new/elements/Form/useForm';
import useConnectionsPage from 'new/components/flows/controller/useConnectionsPage';
import useReranker from 'new/elements/flows/ModalConfigureReranker/useReranker';
import { useSelector } from 'react-redux';

interface SelectConnectionPageProps {}

export const SelectConnectionStep: FCFormPageType<SelectConnectionPageProps> = () => {
  const { nextPage } = useForm();
  const { selectedConnection, onSelectConnection } = useReranker();
  const rerankersAllowed = useSelector((state: any) => state.paging.rerankersAllowed);
  useConnectionsPage(selectedConnection);

  const onConnectionSelected = (selectedConnection: string) => {
    onSelectConnection(selectedConnection);
    nextPage(null, true);
  };

  return (
    <SelectConnection
      overrideConnections={rerankersAllowed}
      connectionType="SINK"
      selectedConnection={selectedConnection}
      onConnectionSelected={onConnectionSelected}
    />
  );
};

SelectConnectionStep.formConfig = {
  title: 'Select',
};
